import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../../hooks/useCart";
import Footer from "../../components/Footer";

// Trash Icon SVG (İkonu doğrudan tanımlayalım)
const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
);

const CartPage = () => {
  console.log("CartPage rendering..."); // Sayfa render oluyor mu?
  const { 
    cartItems, 
    totalAmount, 
    loading, 
    error, 
    refetchCart, 
    removeItemFromCart,
    updateItemQuantity 
  } = useCart();
  const navigate = useNavigate();

  const handleRemoveItem = async (item) => {
    console.log("Kaldırılacak Ürün:", item);
    
    if (!window.confirm(`"${item.product_name}" ürününü sepetten kaldırmak istediğinize emin misiniz?`)) {
      return;
    }

    try {
      const success = await removeItemFromCart(item.dealer_id, item.product_id);
      if (!success) {
        alert("Ürün kaldırılamadı. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      console.error("Ürün kaldırma hatası:", err);
      alert("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleQuantityChange = async (item, newQuantity) => {
    if (newQuantity < 1) return;
    
    try {
      const success = await updateItemQuantity(
        item.dealer_id, 
        item.product_id, 
        newQuantity
      );
      if (!success) {
        alert("Miktar güncellenemedi. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      console.error("Miktar güncelleme hatası:", err);
      alert("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleProceedToCheckout = () => {
    if (cartItems.length === 0) {
      alert("Sepetiniz boş.");
      return;
    }
    
    // Ürün isimlerine göre kategori tahmin et
    const getCategoryFromProductName = (productName) => {
      const name = productName.toLowerCase();
      if (name.includes('halı') || name.includes('kilim')) return "1";
      if (name.includes('koltuk') || name.includes('baza') || name.includes('sandalye')) return "2";
      if (name.includes('perde')) return "3";
      if (name.includes('yorgan') || name.includes('battaniye')) return "4";
      if (name.includes('ev temizliği') || name.includes('temizlik')) return "5";
      return "1"; // Varsayılan halı yıkama
    };
    
    // Sepetteki ürünlerin kategorilerini kontrol et
    const categories = [...new Set(cartItems.map(item => {
      return item.category_id || getCategoryFromProductName(item.product_name);
    }))];
    
    console.log("Sepetteki kategoriler:", categories);
    console.log("Sepet ürünleri:", cartItems.map(item => ({
      name: item.product_name,
      category: getCategoryFromProductName(item.product_name)
    })));
    
    // Kategori bazlı yönlendirme
    let checkoutPath = "/purchase/carpet-cleaning/carpet-details"; // Varsayılan
    
    if (categories.length === 1) {
      // Tek kategori varsa ona göre yönlendir
      const category = categories[0];
      
      // Kategori ID veya ismine göre yönlendirme
      switch (category) {
        case "1":
          checkoutPath = "/purchase/carpet-cleaning/carpet-details";
          break;
        case "2":
          checkoutPath = "/purchase/furniture-cleaning/furniture-details";
          break;
        case "3":
          checkoutPath = "/purchase/curtain-cleaning/curtain-details";
          break;
        case "4":
          checkoutPath = "/purchase/duvet-cleaning/duvet-details";
          break;
        case "5":
          checkoutPath = "/purchase/house-cleaning/house-details";
          break;
        default:
          checkoutPath = "/purchase/general/details";
      }
    } else if (categories.length > 1) {
      // Birden fazla kategori varsa genel checkout flow'a yönlendir
      checkoutPath = "/purchase/mixed-cart/details";
    }
    
    console.log(`Sipariş akışına yönlendiriliyor: ${checkoutPath}`);
    
    // Route mevcut değilse uyarı ver ve varsayılan route'u kullan
    // (Gelecekte bu route'lar eklendiğinde bu kontrol kaldırılabilir)
    if (checkoutPath !== "/purchase/carpet-cleaning/carpet-details") {
      alert(`${checkoutPath} henüz mevcut değil. Halı yıkama akışına yönlendiriliyorsunuz.`);
      checkoutPath = "/purchase/carpet-cleaning/carpet-details";
    }
    
    navigate(checkoutPath);
  };

  // Görüntü URL'sini oluşturma fonksiyonu
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    // Projenizdeki API base URL'ini kullanmanız daha doğru olabilir.
    const API_BASE_URL = "https://api.yikafoni.com";
    return imagePath.startsWith("uploads")
      ? `${API_BASE_URL}/${imagePath}`
      : imagePath;
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <div className="flex-grow container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Sepetim</h1>

        {loading && (
          <p className="text-center text-gray-500 py-10">Sepet yükleniyor...</p>
        )}
        {error && (
          <div className="text-center text-red-500 py-10 bg-red-50 p-4 rounded-lg">
            <p className="font-medium">Hata: {error}</p>
            <button
              onClick={refetchCart}
              className="mt-4 px-4 py-2 border border-red-300 text-red-600 rounded hover:bg-red-100 text-sm font-medium"
            >
              Tekrar Dene
            </button>
          </div>
        )}

        {!loading && !error && cartItems.length === 0 && (
          <div className="text-center text-gray-500 py-16 bg-white p-8 rounded-lg shadow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            <h3 className="mt-2 text-lg font-medium text-gray-900">
              Sepetiniz Boş
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Hemen alışverişe başlayın!
            </p>
            <div className="mt-6">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Anasayfaya Dön
              </Link>
            </div>
          </div>
        )}

        {!loading && !error && cartItems.length > 0 && (
          <div className="lg:flex lg:gap-8 items-start">
            {/* Sepet Ürün Listesi (Sol taraf) */}
            <div className="flex-1 bg-white shadow sm:rounded-lg mb-6 lg:mb-0">
              <ul role="list" className="divide-y divide-gray-200">
                {cartItems.map((item) => {
                  const itemImageUrl = getImageUrl(item.product_image_url);
                  return (
                    <li key={item.cart_item_id} className="p-4 sm:p-6">
                      <div className="flex items-center sm:items-start gap-4">
                        {/* Görsel */}
                        <div className="flex-shrink-0 w-16 h-16 sm:w-20 sm:h-20 rounded-md overflow-hidden border border-gray-200 bg-gray-50 flex items-center justify-center">
                          {itemImageUrl ? (
                            <img
                              src={itemImageUrl}
                              alt={item.product_name}
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          ) : (
                            <span className="text-gray-400 text-xs">
                              Resim Yok
                            </span>
                          )}
                        </div>
                        {/* Detaylar */}
                        <div className="flex-1 min-w-0">
                          <div className="flex justify-between items-start flex-wrap gap-2">
                            <div>
                              <p className="text-sm font-medium text-gray-900 truncate">
                                {item.product_name}
                              </p>
                              {item.dealer_name && (
                                <p className="text-xs text-gray-500 mt-1">
                                  Bayi: {item.dealer_name}
                                </p>
                              )}
                            </div>
                            <button
                              onClick={() => handleRemoveItem(item)}
                              className="ml-4 flex-shrink-0 text-gray-400 hover:text-red-600 transition-colors"
                            >
                              <span className="sr-only">Kaldır</span>
                              <TrashIcon />
                            </button>
                          </div>
                          <div className="flex items-center justify-between mt-2">
                            <div className="flex items-center gap-2">
                              <button
                                onClick={() => handleQuantityChange(item, parseInt(item.quantity) - 1)}
                                disabled={parseInt(item.quantity) <= 1}
                                className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                              >
                                <span className="text-gray-600">-</span>
                              </button>
                              <span className="text-sm font-semibold min-w-[20px] text-center">
                                {item.quantity}
                              </span>
                              <button
                                onClick={() => handleQuantityChange(item, parseInt(item.quantity) + 1)}
                                className="w-8 h-8 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-colors"
                              >
                                <span className="text-gray-600">+</span>
                              </button>
                              <span className="text-sm text-gray-500 ml-2">
                                x {item.price} TL
                              </span>
                            </div>
                            <p className="text-sm font-semibold text-gray-900">
                              {item.total_item_price} TL
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>

            {/* Sipariş Özeti (Sağ taraf) */}
            <div className="w-full lg:w-80 xl:w-96 flex-shrink-0">
              <div className="bg-white shadow sm:rounded-lg p-6 sticky top-24">
                <h2 className="text-lg font-medium text-gray-900 border-b pb-4 mb-4">
                  Sipariş Özeti
                </h2>
                <div className="space-y-3">
                  {/* Ara Toplam vb. eklenebilir */}
                  <div className="flex justify-between text-base font-medium text-gray-900">
                    <p>Toplam Tutar</p>
                    <p>{totalAmount} TL</p>
                  </div>
                  {/* İndirim vb. eklenebilir */}
                  <p className="mt-1 text-xs text-gray-500">
                    Vergiler ve kargo ücretleri ödeme sırasında hesaplanacaktır.
                  </p>
                </div>
                <button
                  onClick={handleProceedToCheckout}
                  className="mt-6 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Siparişi Tamamla
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default CartPage;
